var map = {
	"./AI.png": "c4e8",
	"./bg.png": "dc97",
	"./bg8.png": "aa51",
	"./data-proc-1.png": "c0e0",
	"./data-proc-2.png": "92d2",
	"./data-proc-3.png": "a340",
	"./data-proc-4.png": "21a1",
	"./fav-icon.png": "b20f",
	"./logo-black.png": "1112",
	"./logo-icon.png": "0585",
	"./logo-white.png": "39cc",
	"./money.png": "9443",
	"./pagination1-icon.png": "2834",
	"./pagination2-icon.png": "73e7",
	"./pagination3-icon.png": "29e3",
	"./pagination4-icon.png": "d1bc",
	"./pagination5-icon.png": "6cec",
	"./project1.png": "ccdd",
	"./projects1-icon.png": "6191",
	"./projects1-wide.png": "876d",
	"./projects1.png": "7cf9",
	"./projects2-icon.png": "5ef4",
	"./projects2-wide.png": "a6c0",
	"./projects2.png": "5414",
	"./projects3-icon.png": "e8aa",
	"./projects3-wide.png": "c2ca",
	"./projects3.png": "b947",
	"./projects4-icon.png": "03c9",
	"./projects5-icon.png": "b87b",
	"./speed.png": "2da8",
	"./step-arrow-last.png": "53c0",
	"./step-arrow-top.png": "7e01",
	"./step-arrow.png": "0c74",
	"./tab-icon0.png": "ba8f",
	"./tab-icon1.png": "e673",
	"./tab-icon2.png": "b17e",
	"./tab-icon3.png": "9596",
	"./tab-icon4.png": "7fb5",
	"./team1.png": "7d2f",
	"./team2.png": "6b37",
	"./team3.png": "faa3",
	"./team4.png": "f59d",
	"./team5.png": "a217",
	"./team6.png": "b856",
	"./web-camera.png": "8561",
	"./web-camera1.png": "b65c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7016";